// Client-side SVG → download helpers. No dependencies.

const triggerDownload = (blob, filename) => {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(() => URL.revokeObjectURL(url), 500);
};

export const downloadSVG = (svgElement, filename) => {
    if (!svgElement) return;
    const svgData = new XMLSerializer().serializeToString(svgElement);
    // Prepend XML declaration for maximum compatibility (printing, Illustrator, etc.)
    const withHeader = `<?xml version="1.0" encoding="UTF-8" standalone="no"?>\n${svgData}`;
    const blob = new Blob([withHeader], { type: "image/svg+xml;charset=utf-8" });
    triggerDownload(blob, filename);
};

export const downloadPNG = async (svgElement, filename, { width, height, scale = 2 } = {}) => {
    if (!svgElement) return;
    const svgData = new XMLSerializer().serializeToString(svgElement);
    const svgBlob = new Blob([svgData], { type: "image/svg+xml;charset=utf-8" });
    const svgUrl = URL.createObjectURL(svgBlob);
    try {
        const img = new Image();
        img.crossOrigin = "anonymous";
        await new Promise((resolve, reject) => {
            img.onload = resolve;
            img.onerror = reject;
            img.src = svgUrl;
        });

        const outW = (width || svgElement.viewBox?.baseVal?.width || 800) * scale;
        const outH = (height || svgElement.viewBox?.baseVal?.height || 800) * scale;

        const canvas = document.createElement("canvas");
        canvas.width = outW;
        canvas.height = outH;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, outW, outH);

        await new Promise((resolve) => {
            canvas.toBlob((blob) => {
                if (blob) triggerDownload(blob, filename);
                resolve();
            }, "image/png");
        });
    } finally {
        URL.revokeObjectURL(svgUrl);
    }
};

export const copyToClipboard = async (text) => {
    if (!text) return false;
    try {
        if (navigator.clipboard?.writeText) {
            await navigator.clipboard.writeText(text);
            return true;
        }
    } catch (e) {
        // fallthrough to legacy path
    }
    try {
        const ta = document.createElement("textarea");
        ta.value = text;
        ta.style.position = "fixed";
        ta.style.opacity = "0";
        document.body.appendChild(ta);
        ta.select();
        document.execCommand("copy");
        document.body.removeChild(ta);
        return true;
    } catch (e) {
        return false;
    }
};
